/* 🤖 this file was generated by svg-to-ts */
export const siriusFlagEsEs: {
  name: 'flag_es_es';
  data: string;
} = {
  name: 'flag_es_es',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 24" style="display: block;"><g clip-path="url(#a)"><path fill="#aa151b" d="M0 0h32v24H0z"/><path fill="#f1bf00" d="M0 6h32v12H0z"/></g><rect width="31" height="23" x=".5" y=".5" stroke="#000" stroke-opacity=".2" rx="2.5"/><defs><clipPath id="a"><rect width="32" height="24" fill="#fff" rx="3"/></clipPath></defs></svg>`
};
